import type { EdgeDashStyle, EdgeType } from '../types';

export const EDGE = {
  DEFAULT_STROKE_WIDTH: 1.5,
  DEFAULT_SEQUENCE_MESSAGE_STROKE_WIDTH: 2,
  // 10 levels: 1 → 10
  STROKE_STEPS: [1, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10] as const,
  DASH_CYCLE: ['solid', 'dashed', 'dotted', 'dash-dot', 'long-dash'] as EdgeDashStyle[],
  EDGE_TYPE_CYCLE: ['arrow', 'no-arrow', 'bidirectional'] as EdgeType[],
  DASH_PATTERNS: {
    solid: undefined,
    dashed: [10, 6],
    dotted: [2, 6],
    'dash-dot': [10, 5, 2, 5],
    'long-dash': [20, 8],
  } as Record<EdgeDashStyle, number[] | undefined>,
} as const;
